import { Scorecard } from '@/assets/icons/ats/empty';
import { KText } from '@/ui-library/components';
import { Box, Flex, Icon, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import React, { useEffect } from 'react';

export const JobStages = ({ job = {}, selectedStage, setSelectedStage }) => {
  const { stages = [] } = job;
  //sort the stages according to position
  const sortedStages = [...stages].sort((a, b) => a.position - b.position);
  useEffect(() => {
    // Reset selectedStage when job changes or when stages are empty
    if (sortedStages?.length === 0) {
      setSelectedStage(undefined);
    } else if (
      !sortedStages.find((stage) => stage.id === parseInt(selectedStage))
    ) {
      // If current selection is not in new stages list, select first stage
      setSelectedStage(sortedStages[0]?.id?.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedStages, job.id]); // Add job.id to dependencies to detect job changes

  const handleRadioChange = (value) => {
    setSelectedStage(value);
  };

  if (sortedStages?.length === 0)
    return (
      <Flex
        h="90%"
        w="100%"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <Icon as={Scorecard} w="150px" h="115px" />
        <KText size="sm-medium" mt="36px" mb="9px">
          LOOKS EMPTY IN HERE
        </KText>
        <KText size="lg-semi-bold">This job does not have any stages</KText>
      </Flex>
    );

  return (
    <RadioGroup
      onChange={handleRadioChange}
      value={parseInt(selectedStage)}
      w="100%"
    >
      <Stack w="100%">
        {sortedStages.map(({ id, name }) => (
          <Box
            p="1.24em"
            border="1px solid"
            borderColor="border-color"
            borderRadius="sm"
            minW="100%"
            key={id}
          >
            <Radio value={id}>
              <KText size="sm-medium" mb="2px">
                {name}
              </KText>
            </Radio>
          </Box>
        ))}
      </Stack>
    </RadioGroup>
  );
};
